import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { invalidateSupplierCache, useAddAdminSupplier } from '../../../api/supplier'
import { ScreenTitleBar } from '../../localities/components/ScreenTitleBar'
import { SupplierForm } from './SupplierForm'
import { SupplierTable } from './SupplierTable'
import { ISupplier } from '../../../generated-types'
import { IApiResult } from '../../../generated-types/api-result'
import { toast } from 'react-toastify'
import { useDialogCtx } from 'src/hooks/context-hooks'
import { ShowDialogProps } from 'src/show-dialog'

const CreateSupplierDialog: React.FC<ShowDialogProps> = ({ pop }) => {
  const { t: translate } = useTranslation(['supplier', 'common'])
  const { mutateAsync } = useAddAdminSupplier()

  const onSubmit = async form => {
    await mutateAsync(form)
      .then(({ data }: { data: IApiResult<ISupplier> }) => {
        toast.success(translate(data.message, { ns: 'supplier' }))
        invalidateSupplierCache.useGetSuppliers()
        pop(true)
      })
      .catch(({ data }: { data: string }) => {
        toast.error(translate(data, { ns: 'supplier' }))
      })
  }

  return (
    <SupplierForm
      isSuperAdmin={true}
      title={translate('addSupplier', { ns: 'supplier' })}
      onSubmit={onSubmit}
      onCancel={pop}
    />
  )
}

export const SupplierContainer = () => {
  const { t: translate } = useTranslation(['supplier', 'common'])
  const { showDialog } = useDialogCtx()

  const onAddSupplier = async () => {
    const added = await showDialog(
      CreateSupplierDialog,
      {
        opts: {
          maxWidth: 'sm',
          fullWidth: true,
        },
      },
      undefined,
      true,
    )
    if (!added) return
  }

  return (
    <>
      <Box className="p-3 mb-2 bg-white shadow-md" borderRadius={2}>
        <ScreenTitleBar
          title={translate('suppliers', { ns: 'supplier' })}
          addNewItemText={translate('add', { ns: 'common' })}
          onAddNewItemClick={onAddSupplier}
        />
        <SupplierTable isSuperAdmin={true} height={window.innerHeight - 245 + 'px'} />
      </Box>
    </>
  )
}
